import { useApi } from "../../hooks/use-api";
import { useSingleton } from "../../hooks/use-singleton";
import { useEffect, useState } from "react";
import {
  COOKIE_ACCESS_MAIL,
  COOKIE_ACCESS_ROLE,
} from "../../utils/storage-constants";
import {
  API_BOARD,
  API_GET_BOARD,
  API_GET_CLASS_GRADE,
  API_GET_EDUCTION_LEVEL,
  API_GET_FOCUS,
  API_GET_GENDER,
  API_GET_MEDIUM_OF_INSTRUCTION,
  API_GET_List_MEDIUM_OF_INSTRUCTION,
  API_SIGN_UP,
} from "../../utils/api-routes";
import { useNotify } from "../../hooks/use-notify";
import { useNavigate } from "react-router-dom";
import { ROUTE_LOGIN } from "../../route";

const DEFAULT_ERROR = {
  errEmail: "",
  errPhone: "",
  errName: "",
  errFocus: "",
  errMedium: "",
  errCity: "",
  errInstitution: "",
  errMediumOfInstruction: "",
  errAreaOffocus: "",
  errGender: "",
  errEducationLevel: "",
  errGradeClass: "",
  errBoard: "",
  errState: "",
  errCountry: "",
  errAge: "",
  errSection: "",
  isClicked: false,
  isValid: false,
};

const useHandler = () => {
  const { get, post } = useApi();
  const {
    role,
    board: signletonBoard,
    examType,
    updateRole,
    updateMail,
    updateBoard,
    updateExam,
    updateMedium,
  } = useSingleton();
  const { toggleNotify } = useNotify();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const isEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const textOnlyRegex = /^[A-Za-z\s]+$/;

  const SCHOOL_LEVELS = ["Primary", "Secondary", "Higher Secondary"];
  const COLLEGE_LEVELS = ["Undergraduate", "Postgraduate"];

  // Static grade ranges per level â€” avoids dependency on API string format
  const GRADE_MAP = {
    Primary: ["1", "2", "3", "4", "5"],
    Secondary: ["6", "7", "8", "9", "10"],
    "Higher Secondary": ["11", "12"],
  };

  const [data, setData] = useState({
    email: "",
    name: "",
    phone: "",
    focus: [],
    city: "",
    medium_of_instruction: "",
    institution: "",
    gender: "",
    age: "",
    grade: "",
    level: "",
    board: "",
    country: "",
    state: "",
    section: "",
  });
  const [error, setError] = useState(DEFAULT_ERROR);
  const [boards, setBoards] = useState();
  const [genders, setGenders] = useState([]);
  const [focuss, setFocuss] = useState([]);
  const [gradeClass, setGradeClass] = useState([]);
  const [eductationLevel, setEducationLevel] = useState([]);
  const [mediumInstruction, setMediumInstrction] = useState([]);

  const {
    email,
    name,
    phone,
    focus,
    city,
    medium_of_instruction,
    age,
    gender,
    state,
    country,
    level,
    grade,
    board,
    institution,
    section,
  } = data;
  const { isClicked } = error;

  console.log(data, "data");

  // const onChangeValue = (e) => {
  //   const { name, value } = e.target;
  //   setData((prev) => ({ ...prev, [name]: value }));
  //   setError((prev) => ({
  //     ...prev,
  //     [`err${name.charAt(0).toUpperCase() + name.slice(1)}`]: "",
  //   }));
  // };

  const onChangeValue = (e) => {
    const { name, value } = e.target;

    // When the education level changes, reset the grade selection
    // because the allowed grade range differs per level
    setData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "level" ? { grade: "" } : {}),
    }));

    setError((prev) => ({
      ...prev,
      [`err${name.charAt(0).toUpperCase() + name.slice(1)}`]: "",
      isValid: true, // âœ… reset
    }));
  };

  const onFocusChange = (item) => {
    setData((prev) => {
      const currentFocus = prev.focus;

      const updated = currentFocus.includes(item)
        ? currentFocus.filter((f) => f !== item)
        : [...currentFocus, item];

      getMediumOfInstructions(updated);

      return {
        ...prev,
        focus: updated,
        medium_of_instruction: "",
      };
    });

    setError((prev) => ({
      ...prev,
      errAreaOffocus: "",
      errMediumOfInstruction: "",
      isValid: true,
    }));
  };

  const invalidInputRegex = (input, regex) => new RegExp(regex).test(input);

  const toggleCheck = () => {
    setData((prev) => ({ ...prev, check: !prev.check }));
  };

  const onValidate = (step) => {
    let errState = { ...DEFAULT_ERROR, isValid: true, isClicked: true };

    if (step === 1) {
      if (!name.trim()) {
        errState.errName = "Please Enter Name";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(name.trim())) {
        errState.errName = "Name should contain only letters";
        errState.isValid = false;
      }

      if (!invalidInputRegex(email, isEmail)) {
        errState.errEmail = "Please enter valid Email";
        errState.isValid = false;
      }

      if (!phone || phone.length < 10) {
        errState.errPhone = "Please Enter Your PhoneNumber";
        errState.isValid = false;
      }
    }

    if (step === 2) {
      if (!age) {
        errState.errAge = "Please Enter your Age";
        errState.isValid = false;
      }

      if (!gender) {
        errState.errGender = "Please Choose your Gender";
        errState.isValid = false;
      }
    }

    if (step === 3) {
      if (!city.trim()) {
        errState.errCity = "Please Enter your City";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(city.trim())) {
        errState.errCity = "City should contain only letters";
        errState.isValid = false;
      }

      if (!state.trim()) {
        errState.errState = "Please Enter your State";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(state.trim())) {
        errState.errState = "State should contain only letters";
        errState.isValid = false;
      }

      if (!country.trim()) {
        errState.errCountry = "Please Enter your Country";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(country.trim())) {
        errState.errCountry = "Country should contain only letters";
        errState.isValid = false;
      }
    }

    if (step === 4) {
      const isSchool = SCHOOL_LEVELS.includes(level);
      const isCollege = COLLEGE_LEVELS.includes(level);

      if (!level) {
        errState.errLevel = "Select level";
        errState.isValid = false;
      }

      if (isSchool) {
        if (!grade) {
          errState.errGradeClass = "Select grade";
          errState.isValid = false;
        }
        if (!board) {
          errState.errBoard = "Select board";
          errState.isValid = false;
        }
        if (!section.trim()) {
          errState.errSection = "Select section";
          errState.isValid = false;
        }
      }
    }

    if (step === 5) {
      const isCollege = COLLEGE_LEVELS.includes(level);
      const isCommunicativeEnglish = focus.includes("Communicative English");

      if (!institution.trim()) {
        errState.errInstitution = "Enter institution";
        errState.isValid = false;
      } else if (!textOnlyRegex.test(institution.trim())) {
        errState.errInstitution = "Please enter a valid institute name";
        errState.isValid = false;
      }

      if (!isCommunicativeEnglish && !medium_of_instruction) {
        errState.errMediumOfInstruction = "Select medium";
        errState.isValid = false;
      }
      if (!focus || focus.length === 0) {
        errState.errAreaOffocus = "Select at least one focus area";
        errState.isValid = false;
      }
    }

    setError(errState);
    return errState;
  };

  const getBoards = async () => {
    try {
      const res = await get(API_GET_BOARD);
      if (res) {
        setBoards(res?.data?.board || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API BOARD", e);
    }
  };

  const getGenders = async () => {
    try {
      const res = await get(API_GET_GENDER);
      if (res) {
        setGenders(res?.data?.gender || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API GENDER", e);
    }
  };

  const getEducationLevel = async () => {
    try {
      const res = await get(API_GET_EDUCTION_LEVEL);
      if (res) {
        setEducationLevel(res?.data?.education_level || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API EDUCATIONALLEVEL", e);
    }
  };

  const getClassAndGrade = async () => {
    try {
      const res = await get(API_GET_CLASS_GRADE);
      if (res) {
        setGradeClass(res?.data?.class_grade || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API CLASS AND GRADE", e);
    }
  };

  const getFocus = async () => {
    try {
      const res = await get(API_GET_FOCUS);
      if (res) {
        setFocuss(res?.data?.focus || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API FOCUS", e);
    }
  };

  const getMediumOfInstructions = async (selectedFocus) => {
    try {
      if (!selectedFocus?.length) {
        setMediumInstrction([]);
        return;
      }

      const query = selectedFocus
        .map((item) => `focus=${encodeURIComponent(item)}`)
        .join("&");

      const res = await get(`${API_GET_MEDIUM_OF_INSTRUCTION}?${query}`);

      if (res) {
        setMediumInstrction(res?.data?.medium_of_instruction || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API MEDIUM OF INSTRUCTION", e);
    }
  };

  useEffect(() => {
    getBoards();
  }, []);
  useEffect(() => {
    getGenders();
  }, []);
  useEffect(() => {
    getEducationLevel();
  }, []);
  useEffect(() => {
    getClassAndGrade();
  }, []);

  useEffect(() => {
    getFocus();
  }, []);

  const onSubmit = async () => {
    const { isValid } = onValidate(activeStep);

    if (!isValid) return;
    setIsLoading(true);

    const payload = {
      email: email.trim(),
      name,
      phone,
      level,
      institution,
      city,
      state,
      country,
      age,
      gender,
    };

    if (SCHOOL_LEVELS.includes(level)) {
      payload.class_grade = grade;
      payload.board = board;
      payload.section = section;
    }

    // if (COLLEGE_LEVELS.includes(level)) {
    //   payload.medium_of_instruction = medium_of_instruction;
    //   payload.focus = [focus];
    // }
    // payload.medium_of_instruction = medium_of_instruction;
    payload.medium_of_instruction = focus.includes("Communicative English")
      ? ""
      : medium_of_instruction;

    payload.focus = focus; // array of selected focus areas
    try {
      const response = await post(API_SIGN_UP, payload);
      const apiData = response?.data;

      if (apiData?.role) {
        toggleNotify({
          type: "success",
          title: "Signup Successful",
          description:
            apiData?.message || "You have been registered successfully.",
        });
        navigate(ROUTE_LOGIN, { state: { signupSuccess: true } });
        setIsLoading(false);
        return;
      }

      // Stay on page if signup failed (e.g. user already exists)
      if (!apiData?.role) {
        setIsLoading(false);
        toggleNotify({
          type: "error",
          title: "Signup Failed",
          description:
            apiData?.message || "Something went wrong. Please try again.",
        });
        return;
      }

      const { message } = apiData;

      // âœ… Update context ONLY
      // updateRole(role);
      // updateMail(mail);
      // updateBoard(board);
      updateExam(focus);
      updateMedium(medium_of_instruction);
      // Clear any stale error toast before navigating
      toggleNotify(null);
      navigate(ROUTE_LOGIN, { state: { signupSuccess: true } });
    } catch (error) {
      console.error("Signup error:", error);
      setIsLoading(false);
      const errMsg =
        error?.response?.data?.message ||
        "An error occurred. Please try again.";
      toggleNotify({
        type: "error",
        title: "Signup Failed",
        description: errMsg,
      });
    }
  };

  return {
    SCHOOL_LEVELS,
    COLLEGE_LEVELS,
    data,
    error,
    isLoading,
    boards,
    genders,
    focuss,
    gradeClass,
    mediumInstruction,
    eductationLevel,
    activeStep,
    role,
    board,
    examType,
    signletonBoard,
    setActiveStep,
    setBoards,
    setGenders,
    setFocuss,
    setGradeClass,
    setMediumInstrction,
    setEducationLevel,
    onSubmit,
    onChangeValue,
    onFocusChange,
    toggleCheck,
    onValidate,
    navigate,
  };
};

export default useHandler;
